//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameStatus, WHEEL_MULTIPLIERS } from '../wheel.entity';

const TIMER_TO_START = '距离开始';
const TIMER_WON = '获胜者';
const GAME_STARTED = '进行中';

export default {
  name: 'WheelHomeGameWheelInformation',
  props: {
    gameStatus: {
      type: Number,
      default: GameStatus.ENDED
    },
    // 改为服务端直接下发的剩余秒数
    countdownSeconds: {
      type: Number,
      default: 0
    },
    winColor: {
      type: Number,
      default: undefined
    },
    usersCount: {
      type: Number,
      default: 0
    },
    totalBankUsd: {
      type: Number,
      default: 0
    },
    disableAnimations: {
      type: Boolean,
      default: false
    },
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timerValue: '10.00',
      timerSubtitle: TIMER_TO_START,
      GameStatus,
      animFrameId: null
    };
  },
  computed: {
    formattedUsersCount() {
      return this.usersCount.toLocaleString();
    },
    formattedBank() {
      return `${this.totalBankUsd.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  },
  watch: {
    // 监听状态改变
    gameStatus: {
      immediate: true,
      handler(status) {
        this.updateState();
      }
    },
    // 每次收到 WebSocket 推送更新 countdownSeconds 时，自动刷新/校准倒计时
    countdownSeconds: {
      immediate: true,
      handler(seconds) {
        if (this.gameStatus === GameStatus.CREATED && seconds > 0) {
          this.startCountdown(seconds);
        }
      }
    }
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    updateState() {
      this.stopCountdown();

      if (this.gameStatus === GameStatus.STARTED) {
        this.timerSubtitle = GAME_STARTED;
      } else if (this.gameStatus === GameStatus.CREATED) {
        this.timerSubtitle = TIMER_TO_START;
        if (this.countdownSeconds > 0) {
          this.startCountdown(this.countdownSeconds);
        }
      } else if (this.gameStatus === GameStatus.ENDED) {
        let value = WHEEL_MULTIPLIERS[this.winColor] || '';

        if (this.streamerMode) {
          value = value.replace(/x/gi, '');
        }

        this.timerValue = value;
        this.timerSubtitle = TIMER_WON;
      }
    },

    startCountdown(seconds) {
      this.stopCountdown();

      // 使用 performance.now() 配合服务端给的 seconds 跑本地高精度倒计时
      const startTime = performance.now();
      const totalMs = seconds * 1000;

      const updateTimer = (now) => {
        const elapsed = now - startTime;
        const remainingMs = Math.max(0, totalMs - elapsed);
        const remainingSec = (remainingMs / 1000).toFixed(2);

        // 格式化输出 (不足 5 字符如 "9.50" 则补齐为 "09.50")
        this.timerValue = remainingSec.length < 5 ? `0${remainingSec}` : remainingSec;

        if (remainingMs > 0) {
          this.animFrameId = requestAnimationFrame(updateTimer);
        }
      };

      this.animFrameId = requestAnimationFrame(updateTimer);
    },

    stopCountdown() {
      if (this.animFrameId) {
        cancelAnimationFrame(this.animFrameId);
        this.animFrameId = null;
      }
    }
  }
};
